import React, { Fragment } from "react";
import Moment from "react-moment";

import RedLogo from "../Mentors/RedLogo";
import BlueLogo from "../Employers/BlueLogo";

const Purchases = ({ purchase }) => {
  return (
    <Fragment>
      <div>
        {purchase.purchasetype === "Course" && (
          <div
            className={`purchase ${
              purchase && purchase.role === "innovator"
                ? "green"
                : purchase && purchase.role === "mentor"
                ? "red"
                : purchase && purchase.role === "employer"
                ? "blue"
                : ""
            }`}
          >
            <div className="purchase-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${purchase.avatar}`}
                className="purchase-avi"
              />
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.coursetitle}</p>
              <p className="purchase-type">
                <i className="fas fa-graduation-cap mr-5"></i>Course
              </p>
            </div>
            <div className="purchase-price-container">
              <p
                className={`purchase-date ${
                  purchase && purchase.role === "innovator"
                    ? "green"
                    : purchase && purchase.role === "mentor"
                    ? "red"
                    : purchase && purchase.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>
              </p>
              <p className="price">
                <i className="fas fa-dollar-sign mx-5"></i>10.00
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "Donation" && (
          <div
            className={`purchase ${
              purchase && purchase.role === "innovator"
                ? "green"
                : purchase && purchase.role === "mentor"
                ? "red"
                : purchase && purchase.role === "employer"
                ? "blue"
                : ""
            }`}
          >
            <div className="purchase-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${purchase.avatar}`}
                className="purchase-avi"
              />
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fa-solid fa-circle-dollar-to-slot mr-5"></i>
                Donation
              </p>
            </div>
            <div className="purchase-price-container">
              <p
                className={`purchase-date ${
                  purchase && purchase.role === "innovator"
                    ? "green"
                    : purchase && purchase.role === "mentor"
                    ? "red"
                    : purchase && purchase.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>
              </p>
              <p className="price">
                <i className="fas fa-dollar-sign mx-5"></i>
                {purchase.price}.00
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "IMECourses" && (
          <div className="purchase red">
            <div className="purchase-logo-container">
              <div className="purchase-logo">
                <RedLogo />
              </div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fas fa-graduation-cap mr-5"></i>Courses
              </p>
            </div>
            <div className="purchase-price-container">
              <p
                className={`purchase-date ${
                  purchase && purchase.role === "innovator"
                    ? "green"
                    : purchase && purchase.role === "mentor"
                    ? "red"
                    : purchase && purchase.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>
              </p>
              <p className="price">
                <i className="fas fa-dollar-sign mx-5"></i>30.00
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "MentorSubscription" && (
          <div className="purchase red">
            <div className="purchase-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${purchase.avatar}`}
                className="purchase-avi"
              />
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fas fa-user-check mr-5"></i>Monthly Subscription
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>5.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "MentorSubscriptionAnnual" && (
          <div className="purchase red">
            <div className="purchase-logo-container">
              <div className="purchase-logo">
                <RedLogo />
              </div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fas fa-user-check mr-5"></i>Mentor Annual
                Subscription
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>60.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "MentorGiftedSubscription" && (
          <div className="purchase red">
            <div className="purchase-avi-container">
              <div className="purchase-avi"></div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fas fa-gift mr-5"></i>Gifted Subscription to (user
                name)
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>5.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "IMECoursesGiftedSubscription" && (
          <div className="purchase red">
            <div className="purchase-avi-container">
              <div className="purchase-avi"></div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.description}</p>
              <p className="purchase-type">
                <i className="fas fa-gift mr-5"></i>Gifted Subscription to (user
                name)
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>30.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "GiftedCourse" && (
          <div className="purchase red">
            <div className="purchase-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${purchase.avatar}`}
                className="purchase-avi"
              />
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">{purchase.coursetitle}</p>
              <p className="purchase-type">
                <i className="fas fa-gift mr-5"></i>Gifted Course from{" "}
                {!purchase.anonymous && purchase.gifting_user_firstname}{" "}
                {!purchase.anonymous && purchase.gifting_user_lastname}{" "}
                {!purchase.anonymous && purchase.gifting_user_channelid}{" "}
                {purchase.anonymous && "Anonymous"} to{" "}
                {purchase.gifted_user_firstname} {purchase.gifted_user_lastname}{" "}
                ({purchase.gifted_user_channelid})
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>10.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "IMESilverPackage" && (
          <div className="purchase blue">
            <div className="purchase-logo-container">
              <div className="purchase-logo">
                <BlueLogo />
              </div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">Silver Package ime Subscription</p>
              <p className="purchase-type">
                <i className="fas fa-medal mr-5"></i>Employer Subscription
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>100.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "IMEGoldPackage" && (
          <div className="purchase blue">
            <div className="purchase-logo-container">
              <div className="purchase-logo">
                <BlueLogo />
              </div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">Gold Package ime Subscription</p>
              <p className="purchase-type">
                <i className="fas fa-medal mr-5"></i>Employer Subscription
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>300.00{" "}
              </p>
            </div>
          </div>
        )}
        {purchase.purchasetype === "IMEPlatinumPackage" && (
          <div className="purchase blue">
            <div className="purchase-logo-container">
              <div className="purchase-logo">
                <BlueLogo />
              </div>
            </div>
            <div className="purchase-info-container">
              <p className="purchase-info">Platinum Package ime Subscription</p>
              <p className="purchase-type">
                <i className="fas fa-medal mr-5"></i>Employer Subscription
              </p>
            </div>
            <div className="purchase-price-container">
              <p className="purchase-date">
                {" "}
                <i className="far fa-calendar mx-5"></i>
                <Moment format="MM/DD/YYYY">{purchase.date}</Moment>{" "}
              </p>
              <p className="price">
                {" "}
                <i className="fas fa-dollar-sign mx-5"></i>500.00{" "}
              </p>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Purchases;
